import React, { useEffect, useState } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import TableLoading from '../commonUIComponents/TableLoading'
import { useSnackbar } from 'notistack'
import ArchiveIcon from '@mui/icons-material/Archive'
import RecyclingIcon from '@mui/icons-material/Recycling'
import reportService from '../../services/reportService'
import Moment from 'react-moment'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'

const ReportedCommentsPage = () => {
  const [reportedComments, setReportedComments] = useState()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [isLastPage, setIsLastPage] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    setReportedComments(null)
    fetchReportedComments()
  }, [page])

  const paginationHandler = () => {
    setPage(page + 1)
  }

  const fetchReportedComments = () => {
    setLoading(true)
    reportService.getReportedComments(page, pageSize)
      .then(res => {
        if (reportedComments && page > 0) {
          setReportedComments([...reportedComments, ...res.reportedComments])
        } else {
          setReportedComments(res.reportedComments)
        }
        console.log(res)
        setIsLastPage(res.pagination.isLastPage)
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  const updateRow = reportId => {
    const currentReportedComments = [...reportedComments]
    currentReportedComments.forEach(reportedComment => {
      if (reportedComment.id === reportId) {
        reportedComment.archived = !reportedComment.archived
      }
    })
    setReportedComments(currentReportedComments)
  }

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Comment ID</TableCell>
            <TableCell>Comment</TableCell>
            <TableCell>Reporter</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Date</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reportedComments?.map(reportedComment => (
            <TableRow key={reportedComment.id}>
              <TableCell>
                <Typography component={Link} to={`/view-post/${reportedComment.postId}?highlightedCommentId=${reportedComment.commentId}`} target="_blank">
                  {reportedComment.commentId}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography component={Link} to={`/view-post/${reportedComment.postId}?highlightedCommentId=${reportedComment.commentId}`} target="_blank">
                  {reportedComment.body}
                </Typography>
              </TableCell>
              <TableCell>{reportedComment.nickname}</TableCell>
              <TableCell>{reportedComment.category}</TableCell>
              <TableCell>{reportedComment.reason}</TableCell>
              <TableCell>
                <Moment format="DD/MM/YYYY HH:mm:ss">{reportedComment.createdDate}</Moment>
              </TableCell>
              <TableCell>
                {!reportedComment.archived
                  ? (
                    <IconButton onClick={() => {
                      reportService.updateArchive(reportedComment.id, { archived: true }).then(res => updateRow(reportedComment.id))
                    }}>
                      <ArchiveIcon />
                    </IconButton>
                    )
                  : (
                    <IconButton onClick={() => {
                      reportService.updateArchive(reportedComment.id, { archived: false }).then(res => updateRow(reportedComment.id))
                    }}>
                      <RecyclingIcon />
                    </IconButton>
                    )
                }
              </TableCell>
            </TableRow>
          ))}
          {!isLastPage && !loading
            ? (
              <TableRow>
                <Button onClick={paginationHandler}>Show More</Button>
              </TableRow>
              )
            : undefined
          }
          <TableLoading loading={loading} colSpan={3}/>
        </TableBody>
      </Table>
    </div>
  )
}

export default ReportedCommentsPage
